
/*
=============================================================================
auto-generated ***
to refresh you will need to run
npm run build:model
This code was generated by a tool.
¯\_(ツ)_/¯

Changes to this file may cause incorrect behavior and will be lost if
the code is regenerated.
=============================================================================
*/

export const $cat_$accounts_receivable_id: string = "c4d3ccf4-b08d-ec11-b400-0022480b6b1d";
export const $cat_$accounts_receivable_name: string = "Accounts Receivable";
export const $cat_$ancillary_id: string = "5b49cc24-d63c-ec11-b6e5-0022480a9561";
export const $cat_$ancillary_name: string = "Ancillary";
export const $cat_$cobra_id: string = "e92df336-d63c-ec11-b6e5-0022480a9561";
export const $cat_$cobra_name: string = "COBRA";
export const $cat_$capital_prime_id: string = "c68cf3b7-d54e-f111-bec7-6045bddba643";
export const $cat_$capital_prime_name: string = "Capital Prime";
export const $cat_$dental_id: string = "9ccc3835-a832-ec11-b6e5-0022480ab88f";
export const $cat_$dental_name: string = "Dental";
export const $cat_$fsa_id: string = "a7605d43-d63c-ec11-b6e5-0022480a9561";
export const $cat_$fsa_name: string = "FSA";
export const $cat_$fees_and_premiums_id: string = "7c8c262c-d778-ec11-8d21-0022480b0e40";
export const $cat_$fees_and_premiums_name: string = "Fees and Premiums";
export const $cat_$florida_prime_id: string = "17a5192c-966f-ef11-a670-6045bddbb564";
export const $cat_$florida_prime_name: string = "Florida Prime";
export const $cat_$group_configuration_id: string = "4f432ecf-bc5d-ec11-8f8f-000d3a342d18";
export const $cat_$group_configuration_name: string = "Group Configuration";
export const $cat_$group_number_id: string = "23153cda-d08d-ec11-b400-0022480b6b1d";
export const $cat_$group_number_name: string = "Group Number";
export const $cat_$hra_id: string = "c884574f-d63c-ec11-b6e5-0022480a9561";
export const $cat_$hra_name: string = "HRA";
export const $cat_$hsa_id: string = "f9466555-d63c-ec11-b6e5-0022480a9561";
export const $cat_$hsa_name: string = "HSA";
export const $cat_$lsa_id: string = "9d86ede9-2a53-ee11-be6f-000d3a305861";
export const $cat_$lsa_name: string = "LSA";
export const $cat_$medical_id: string = "42ad9a7f-d63c-ec11-b6e5-0022480a9561";
export const $cat_$medical_name: string = "Medical";
export const $cat_$non_standard_id: string = "a0c3f887-d28d-ec11-b400-0022480b6b1d";
export const $cat_$non_standard_name: string = "Non-Standard";
export const $cat_$non_standard_template_id: string = "f4e24072-700c-ef11-9f89-6045bdeb64f8";
export const $cat_$non_standard_template_name: string = "Non-Standard Template";
export const $cat_$pharmacy_id: string = "cd48a185-d63c-ec11-b6e5-0022480a9561";
export const $cat_$pharmacy_name: string = "Pharmacy";
export const $cat_$plan_id: string = "d33bde62-d55d-ec11-8f8f-000d3a342d18";
export const $cat_$plan_name: string = "Plan";
export const $cat_$quote_request_id: string = "ed7b784a-38d0-ee11-9079-002248081a21";
export const $cat_$quote_request_name: string = "Quote Request";
export const $cat_$stop_loss_id: string = "c1816640-d778-ec11-8d21-0022480b0e40";
export const $cat_$stop_loss_name: string = "Stop Loss";
export const $cat_$system_id: string = "46072692-312d-f111-88b4-000d3a10d29d";
export const $cat_$system_name: string = "System";
export const $cat_$telehealth_id: string = "c78645e0-9342-ee11-bdf4-00224808116e";
export const $cat_$telehealth_name: string = "Telehealth";
export const $cat_$vision_id: string = "886aba91-d63c-ec11-b6e5-0022480a9561";
export const $cat_$vision_name: string = "Vision";
